



























































































































































































import moment from 'moment';
import { mapActions } from 'vuex';
import { get } from 'vuex-pathify';
import { Transition } from '@/models/transition';
import { ErrorManager } from '@/models/error';
import PaymentRequisitionCommentListItem from './PaymentRequisitionCommentListItem.vue';
import ErrorAlert from '../common/ErrorAlert.vue';
import auth from '@/mixins/auth';
import colorable from '@/mixins/colorable';
import mixins from '@/utils/mixins';
import {
  IAttachment,
  IPaymentRequisition,
  IPaymentRequisitionComment,
  PaymentRequisitionComment,
  PaymentRequisitionCommentAttachment,
  PaymentRequisitionStatus,
  PaymentRequisitionStatusEnum
} from '@/models';
import { PropType } from 'vue';
import { AxiosError } from 'axios';
import { IUser } from '@/models';
import { isHtmlTextEmpty, setErrorFromAxiosError } from '@/utils/helpers';
import QuillEditor from '../common/QuillEditor.vue';

import CommentAttachmentList from '@/components/common/CommentAttachmentList.vue';

export default mixins(auth, colorable).extend({
  components: {
    CommentAttachmentList,
    ErrorAlert,
    PaymentRequisitionCommentListItem,
    QuillEditor
  },
  name: 'PaymentRequisitionDetailActivityCard',

  props: {
    paymentRequisition: {
      type: Object as PropType<IPaymentRequisition>,
      required: true
    }
  },

  data: () => ({
    loading: false,

    errorMessage: '',
    detailErrorMessage: '',
    currentTab: 0,

    paymentRequisitionCommentValid: '',
    comment: new PaymentRequisitionComment(),
    commentLoading: false,
    commentErrorMessage: '',
    commentDetailErrorMessage: '',

    mentionsLoading: false,

    attachments: [] as IAttachment[]
  }),

  computed: {
    paymentRequisitionComments: get<IPaymentRequisitionComment[]>(
      'paymentRequisition/getPaymentRequisitionComments'
    ),

    paymentRequisitionActivities: get<Transition[]>(
      'paymentRequisition/getPaymentRequisitionActivities'
    ),

    PaymentRequisitionStatus: () => PaymentRequisitionStatus,

    mentionableUsers: get<IUser[]>(
      'paymentRequisition/getPaymentRequisitionMentionableUsers'
    ),

    getLastCreatedPaymentRequisitionCommentId: get<number>(
      'paymentRequisition/getLastCreatedPaymentRequisitionCommentId'
    ),

    canSaveComment(): boolean {
      return !isHtmlTextEmpty(this.comment.text) && !this.commentLoading;
    }
  },

  methods: {
    timeFromNow: (date: Date | string) => {
      return moment(date).fromNow();
    },

    ...mapActions({
      fetchPaymentRequisitionActivities:
        'paymentRequisition/fetchPaymentRequisitionActivities',
      fetchPaymentRequisitionComments:
        'paymentRequisition/fetchPaymentRequisitionComments',
      createPaymentRequisitionComment:
        'paymentRequisition/createPaymentRequisitionComment',
      fetchPaymentRequisitionCommentsMentionableUsers:
        'paymentRequisition/fetchPaymentRequisitionCommentsMentionableUsers',

      addPaymentRequisitionCommentAttachments:
        'paymentRequisition/addPaymentRequisitionCommentAttachments'
    }),

    addBaseAttachments(files: File[]) {
      this.attachments.push(
        ...files.map(
          file => new PaymentRequisitionCommentAttachment({ file: file })
        )
      );
    },

    clearAllErrors(): void {
      this.errorMessage = '';
      this.detailErrorMessage = '';

      this.commentErrorMessage = '';
      this.commentDetailErrorMessage = '';
    },

    getInitials(name: string) {
      return name
        .toUpperCase()
        .split(' ')
        .map(n => n[0])
        .join('');
    },

    addPaymentRequisitionComment() {
      this.clearAllErrors();

      this.commentLoading = true;

      const parsedCommentMentionText = PaymentRequisitionComment.parseHtmlToMentionText(
        this.comment.text
      );

      return this.createPaymentRequisitionComment({
        requisitionId: this.paymentRequisition.id,
        comment: { ...this.comment, text: parsedCommentMentionText }
      })
        .then(async () => {
          this.comment = new PaymentRequisitionComment();
          if (this.attachments.length !== 0) {
            await this.addPaymentRequisitionCommentAttachments({
              requisitionId: this.paymentRequisition.id,
              commentId: this.getLastCreatedPaymentRequisitionCommentId,
              attachments: this.attachments
            });
            this.attachments = [];
          }
        })
        .catch(error => {
          if (error.response) {
            if (error.response.data.detail) {
              this.commentDetailErrorMessage = error.response.data.detail;
            }
          }
          this.commentErrorMessage = ErrorManager.extractApiError(error);
        })
        .finally(() => {
          this.commentLoading = false;
        });
    },

    getStatusMessage(state: PaymentRequisitionStatusEnum): string {
      return PaymentRequisitionStatus.getStatusMessageFromState(state);
    },

    async loadMentionableUsers() {
      this.clearAllErrors();

      this.mentionsLoading = true;
      try {
        await this.fetchPaymentRequisitionCommentsMentionableUsers(
          this.paymentRequisition.id
        );
      } catch (error) {
        this.commentErrorMessage = setErrorFromAxiosError(
          error as AxiosError
        ).message;
      } finally {
        this.mentionsLoading = false;
      }
    }
  },

  async mounted() {
    this.loading = true;
    try {
      await this.fetchPaymentRequisitionComments(this.paymentRequisition.id);
      await this.fetchPaymentRequisitionActivities(this.paymentRequisition.id);
    } catch (err) {
      const error = err as AxiosError;
      if (error.response) {
        if (error.response.data.detail) {
          this.detailErrorMessage = error.response.data.detail;
        }
      }
      this.errorMessage = ErrorManager.extractApiError(error);
    } finally {
      this.loading = false;
    }
  }
});
